import { createRoute, redirect } from '@tanstack/react-router';
import { loadSession, rootRoute } from '../../router/parents';
import { PlatformActivityPage } from './activity';
import { PlatformCompanySuppliersPage } from './company-suppliers';
import { PlatformCompanyTeamPage } from './company-team';
import { PlatformCompanyTemplatesPage } from './company-templates';
import { PlatformHomePage, PlatformLayout, PlatformWorkspacePage } from './pages';
import { PlatformUserPage } from './user-detail';
import { PlatformUsersPage } from './users';

/**
 * /admin: BuildBee platform console. Outside the workspace shell (a super admin belongs to no
 * workspace); signed-in users only, and the page itself checks `platform.me` (the API enforces it).
 */
const platformRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/admin',
  beforeLoad: async ({ context, location }) => {
    if (!(await loadSession(context.queryClient))) throw redirect({ to: '/sign-in', search: { redirect: location.href } });
  },
  component: PlatformLayout,
});

const platformHomeRoute = createRoute({ getParentRoute: () => platformRoute, path: '/', component: PlatformHomePage });

const platformWorkspaceRoute = createRoute({
  getParentRoute: () => platformRoute,
  path: '/workspaces/$workspaceId',
  component: function PlatformWorkspaceRoute() {
    const { workspaceId } = platformWorkspaceRoute.useParams();
    return <PlatformWorkspacePage workspaceId={workspaceId} />;
  },
});

const platformCompanyTeamRoute = createRoute({
  getParentRoute: () => platformRoute,
  path: '/workspaces/$workspaceId/team',
  component: function PlatformCompanyTeamRoute() {
    const { workspaceId } = platformCompanyTeamRoute.useParams();
    return <PlatformCompanyTeamPage workspaceId={workspaceId} />;
  },
});

const platformCompanyTemplatesRoute = createRoute({
  getParentRoute: () => platformRoute,
  path: '/workspaces/$workspaceId/templates',
  component: function PlatformCompanyTemplatesRoute() {
    const { workspaceId } = platformCompanyTemplatesRoute.useParams();
    return <PlatformCompanyTemplatesPage workspaceId={workspaceId} />;
  },
});

const platformCompanySuppliersRoute = createRoute({
  getParentRoute: () => platformRoute,
  path: '/workspaces/$workspaceId/suppliers',
  component: function PlatformCompanySuppliersRoute() {
    const { workspaceId } = platformCompanySuppliersRoute.useParams();
    return <PlatformCompanySuppliersPage workspaceId={workspaceId} />;
  },
});

const platformUsersRoute = createRoute({ getParentRoute: () => platformRoute, path: '/users', component: PlatformUsersPage });

const platformUserRoute = createRoute({
  getParentRoute: () => platformRoute,
  path: '/users/$userId',
  component: function PlatformUserRoute() {
    const { userId } = platformUserRoute.useParams();
    return <PlatformUserPage userId={userId} />;
  },
});

const platformActivityRoute = createRoute({ getParentRoute: () => platformRoute, path: '/activity', component: PlatformActivityPage });

export const platformRoutes = [
  platformRoute.addChildren([
    platformHomeRoute,
    platformWorkspaceRoute,
    platformCompanyTeamRoute,
    platformCompanyTemplatesRoute,
    platformCompanySuppliersRoute,
    platformUsersRoute,
    platformUserRoute,
    platformActivityRoute,
  ]),
] as const;
